import React, {useState, useEffect, useRef} from "react";

function Highlighter(props) {

    console.log(props.style)

    const colors = props.colors;

    const [isVisible, setVisible] = useState(true);
    const domRef = useRef();

    //check to see if the words are visible
    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
        });
        observer.observe(domRef.current);
        return () => observer.unobserve(domRef.current);
    }, []);

return (
    <div className="highlight-wrapper" style={props.style}>
        <div
        className={`highlighted-area ${isVisible ? 'is-visible' : ''}`}
        style={{backgroundColor: colors["dark2"]}}
        ref={domRef}>
            <p style={{color: colors["dark2"]}}>.</p>
        </div>
    </div>
);
};

export default Highlighter;